// src/components/CivilIcons.js
// Custom SVG icons for civil engineering theme

// ================================
// CEMENT & CONSTRUCTION EQUIPMENT
// ================================

export const CementMixerIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <ellipse cx="10" cy="11" rx="7" ry="6" />
    <path d="M17 11l3-2v4l-3-2" />
    <path d="M3 11V9" />
    <line x1="6" y1="20" x2="6" y2="17" />
    <line x1="14" y1="20" x2="14" y2="17" />
    <circle cx="6" cy="21" r="1" />
    <circle cx="14" cy="21" r="1" />
    <path d="M4 17h12" />
  </svg>
);

export const ConcreteTruckIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M2 14h6v4H2z" />
    <path d="M8 10h10l2 4v4H8z" />
    <path d="M10 10l2-6h5l1 6" />
    <circle cx="5" cy="20" r="2" />
    <circle cx="17" cy="20" r="2" />
    <line x1="7" y1="18" x2="15" y2="18" />
    <path d="M13 4l3 0" />
  </svg>
);

export const WheelbarrowIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M6 14l-3 6" />
    <path d="M18 14l3 6" />
    <circle cx="12" cy="20" r="2" />
    <path d="M4 14h16l-2-8H6z" />
    <path d="M8 6h8" />
    <line x1="12" y1="14" x2="12" y2="18" />
  </svg>
);

export const TrowelIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M14 3l7 7-10 10H4v-7z" />
    <line x1="4" y1="20" x2="11" y2="13" />
    <path d="M17 6l1-1" />
  </svg>
);

export const CraneTowerIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <line x1="12" y1="2" x2="12" y2="22" />
    <line x1="4" y1="2" x2="20" y2="2" />
    <line x1="4" y1="2" x2="4" y2="6" />
    <line x1="20" y1="2" x2="20" y2="4" />
    <line x1="20" y1="4" x2="20" y2="8" />
    <path d="M12 6l8-4" />
    <path d="M12 6l-4 2" />
    <line x1="10" y1="22" x2="14" y2="22" />
    <line x1="9" y1="22" x2="15" y2="22" />
  </svg>
);

export const ShovelIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M18.5 5.5l-1.4-1.4a2 2 0 00-2.8 0L7 11.4V17h5.6l7.3-7.3a2 2 0 000-2.8z" />
    <line x1="2" y1="22" x2="7" y2="17" />
  </svg>
);

export const ConcreteBlockIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M2 16l10 5 10-5" />
    <path d="M2 11l10 5 10-5" />
    <path d="M2 6l10 5 10-5L12 1z" />
  </svg>
);

export const HelmetIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M2 18h20" />
    <path d="M4 18c0-4.4 3.6-8 8-8s8 3.6 8 8" />
    <path d="M4 14h16" />
    <path d="M12 6V4" />
    <path d="M12 10c-2.2 0-4 1.3-4 3" />
  </svg>
);

export const BuildingIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="3" y="3" width="7" height="18" rx="1" />
    <rect x="14" y="8" width="7" height="13" rx="1" />
    <line x1="6" y1="7" x2="6" y2="7.01" />
    <line x1="6" y1="11" x2="6" y2="11.01" />
    <line x1="6" y1="15" x2="6" y2="15.01" />
    <line x1="17" y1="12" x2="17" y2="12.01" />
    <line x1="17" y1="16" x2="17" y2="16.01" />
  </svg>
);

export const BridgeIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M2 18h20" />
    <path d="M4 18V8" />
    <path d="M20 18V8" />
    <path d="M4 8c0 0 4-4 8-4s8 4 8 4" />
    <path d="M8 18v-4" />
    <path d="M12 18v-6" />
    <path d="M16 18v-4" />
  </svg>
);

export const BlueprintIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <line x1="3" y1="9" x2="21" y2="9" />
    <line x1="9" y1="3" x2="9" y2="21" />
    <line x1="15" y1="9" x2="15" y2="21" />
    <line x1="9" y1="15" x2="21" y2="15" />
  </svg>
);

export const ConcreteIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M2 20h20" />
    <path d="M4 20v-6l2-2h12l2 2v6" />
    <path d="M8 12V8l4-4 4 4v4" />
    <circle cx="12" cy="16" r="2" />
  </svg>
);

export const SurveyIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 2v4" />
    <path d="M12 6l6 14" />
    <path d="M12 6L6 20" />
    <path d="M8 16h8" />
    <circle cx="12" cy="2" r="1" />
  </svg>
);

export const StructureIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M3 21h18" />
    <path d="M5 21V7l7-4 7 4v14" />
    <path d="M9 21v-6h6v6" />
    <line x1="9" y1="9" x2="9" y2="9.01" />
    <line x1="15" y1="9" x2="15" y2="9.01" />
    <line x1="9" y1="13" x2="9" y2="13.01" />
    <line x1="15" y1="13" x2="15" y2="13.01" />
  </svg>
);

export const LeafIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M17 8C8 10 5.9 16.17 3.82 21.34L5.71 22l1-2.3A4.49 4.49 0 008 20c4 0 8.68-3 11.5-8.5C21 8.5 21 3 21 3s-4 .5-4 5" />
    <path d="M14 9a4.74 4.74 0 00-4 2" />
  </svg>
);

export const ResearchIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M9 3h6v4a3 3 0 01-3 3v0a3 3 0 01-3-3V3z" />
    <path d="M12 10v4" />
    <path d="M8 14h8" />
    <path d="M7 14v3a2 2 0 002 2h6a2 2 0 002-2v-3" />
    <line x1="9" y1="3" x2="8" y2="1" />
    <line x1="15" y1="3" x2="16" y2="1" />
  </svg>
);

export const HardHatIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M2 18h20" />
    <path d="M4 18v-2a8 8 0 0116 0v2" />
    <path d="M12 6V2" />
    <path d="M8 14h8" />
  </svg>
);

export const GraduationIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M22 10l-10-6L2 10l10 6 10-6z" />
    <path d="M6 12v5c0 0 2.5 3 6 3s6-3 6-3v-5" />
    <line x1="22" y1="10" x2="22" y2="16" />
  </svg>
);

export const AwardIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="9" r="6" />
    <path d="M8.5 15l-1.5 6 5-3 5 3-1.5-6" />
    <path d="M12 6v0" />
  </svg>
);

export const DocumentIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
    <polyline points="14,2 14,8 20,8" />
    <line x1="8" y1="13" x2="16" y2="13" />
    <line x1="8" y1="17" x2="16" y2="17" />
  </svg>
);

export const TeamIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="9" cy="7" r="3" />
    <path d="M3 21v-2a4 4 0 014-4h4a4 4 0 014 4v2" />
    <circle cx="18" cy="8" r="2.5" />
    <path d="M21 21v-1.5a3 3 0 00-3-3h-.5" />
  </svg>
);

export const MailIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="M22 7l-10 7L2 7" />
  </svg>
);

export const PhoneIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 012.12 4.18 2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
  </svg>
);

export const LocationIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

export const LinkedInIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

export const ArrowRightIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12,5 19,12 12,19" />
  </svg>
);

export const CheckIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <polyline points="20,6 9,17 4,12" />
  </svg>
);

export const CalendarIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

export const ExternalLinkIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6" />
    <polyline points="15,3 21,3 21,9" />
    <line x1="10" y1="14" x2="21" y2="3" />
  </svg>
);

export const MenuIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

export const CloseIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export const SendIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <line x1="22" y1="2" x2="11" y2="13" />
    <polygon points="22,2 15,22 11,13 2,9" />
  </svg>
);

export const FilterIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <polygon points="22,3 2,3 10,12.46 10,19 14,21 14,12.46" />
  </svg>
);

export const TrophyIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M6 9H4a2 2 0 01-2-2V5a2 2 0 012-2h2" />
    <path d="M18 9h2a2 2 0 002-2V5a2 2 0 00-2-2h-2" />
    <path d="M6 3h12v6a6 6 0 01-12 0V3z" />
    <path d="M10 16h4" />
    <path d="M12 16v4" />
    <path d="M8 22h8" />
  </svg>
);

export const ClockIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="10" />
    <polyline points="12,6 12,12 16,14" />
  </svg>
);

export const TrendingUpIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <polyline points="23,6 13.5,15.5 8.5,10.5 1,18" />
    <polyline points="17,6 23,6 23,12" />
  </svg>
);

export const TargetIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="6" />
    <circle cx="12" cy="12" r="2" />
  </svg>
);

export const BriefcaseIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="2" y="7" width="20" height="14" rx="2" />
    <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" />
    <line x1="2" y1="13" x2="22" y2="13" />
  </svg>
);

export const HomeIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
    <polyline points="9,22 9,12 15,12 15,22" />
  </svg>
);

export const BookIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M4 19.5A2.5 2.5 0 016.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" />
    <line x1="8" y1="7" x2="16" y2="7" />
    <line x1="8" y1="11" x2="13" y2="11" />
  </svg>
);

export const UserIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="8" r="4" />
    <path d="M20 21a8 8 0 10-16 0" />
  </svg>
);

export const AlertIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);

export const WrenchIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z" />
  </svg>
);

export const LightbulbIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M9 18h6" />
    <path d="M10 22h4" />
    <path d="M12 2a7 7 0 00-4 12.7V17h8v-2.3A7 7 0 0012 2z" />
  </svg>
);

export const ShieldIcon = ({ className = "h-6 w-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <polyline points="9,12 11,14 15,10" />
  </svg>
);
